var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomservice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 20.5H9C8.72386 20.5 8.5 20.2761 8.5 20C8.5 19.7239 8.72386 19.5 9 19.5H11.5C11.7761 19.5 12 19.2761 12 19C12 18.4477 11.5523 18 11 18H5.5C5.22386 18 5 18.2239 5 18.5V22.5C5 22.7761 5.22386 23 5.5 23H19.5C19.7761 23 20 22.7761 20 22.5C20 21.3954 19.1046 20.5 18 20.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1486 10.8117C21.0536 10.9309 20.9094 11.0002 20.757 11H3.24298C3.09058 11.0002 2.94638 10.9309 2.85135 10.8117C2.75632 10.6926 2.72086 10.5366 2.75497 10.388C3.55759 6.88834 6.26276 4.13907 9.74899 3.28C9.88556 3.24701 10.002 3.15811 10.0697 3.035C10.1374 2.91193 10.1502 2.76602 10.105 2.633C10.0353 2.42926 9.99979 2.21536 10 2C10 0.895416 10.8954 0 12 0C13.1046 0 14 0.895416 14 2C14.0002 2.21536 13.9647 2.42926 13.895 2.633C13.8498 2.76602 13.8626 2.91193 13.9303 3.035C13.998 3.15811 14.1144 3.24701 14.251 3.28C17.7372 4.13907 20.4424 6.88834 21.245 10.388C21.2791 10.5366 21.2437 10.6926 21.1486 10.8117ZM10.506 5.215C9.22855 5.49377 8.03528 6.07123 7.02399 6.89999C6.70309 7.16287 6.6561 7.63611 6.91898 7.957C7.18188 8.27786 7.65512 8.32489 7.97598 8.06198C8.80225 7.38293 9.77805 6.90994 10.823 6.68201C11.2281 6.59445 11.4855 6.1951 11.398 5.78998C11.3105 5.38489 10.9111 5.12744 10.506 5.215Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 12H0.75C0.335786 12 0 12.3358 0 12.75C0 13.1642 0.335786 13.5 0.75 13.5H1.586C1.71835 13.5 1.84529 13.5525 1.939 13.646L3 14.707C3.18749 14.8945 3.44181 14.9999 3.707 15H20.293C20.5582 14.9999 20.8125 14.8945 21 14.707L22.061 13.646C22.155 13.5523 22.2823 13.4998 22.415 13.5H23.25C23.6642 13.5 24 13.1642 24 12.75C24 12.3358 23.6642 12 23.25 12Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 17H3C3.55228 17 4 17.4477 4 18V23C4 23.5523 3.55228 24 3 24H1C0.447723 24 0 23.5523 0 23V18C0 17.4477 0.447723 17 1 17ZM1 21.75C1 22.1642 1.33578 22.5 1.75 22.5C2.16422 22.5 2.5 22.1642 2.5 21.75C2.5 21.3358 2.16422 21 1.75 21C1.33578 21 1 21.3358 1 21.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomservice);
export default __webpack_public_path__ + "static/media/roomservice.0b1e040c.svg";
export { ForwardRef as ReactComponent };